const PasswordIcon = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "20"}
      height={height ? height : "22"}
      fill="none"
      viewBox="0 0 20 24"
      className="ml-1 mb-1"
    >
      <path
        fill="#BAB5B5"
        d="M16.06 23.555H3.213A3.216 3.216 0 010 20.343v-8.565a3.216 3.216 0 013.212-3.212h12.849a3.216 3.216 0 013.212 3.212v8.565a3.216 3.216 0 01-3.212 3.212zM3.213 10.707c-.589 0-1.07.48-1.07 1.07v8.566c0 .591.481 1.071 1.07 1.071h12.849c.588 0 1.07-.48 1.07-1.07v-8.566c0-.591-.482-1.07-1.07-1.07H3.212z"
      ></path>
      <path
        fill="#BAB5B5"
        d="M13.92 10.707H5.353c-.591 0-1.071-.48-1.071-1.07V5.353A5.36 5.36 0 019.636 0a5.36 5.36 0 015.354 5.354v4.282c0 .591-.48 1.071-1.07 1.071zM6.423 8.566h6.424V5.354A3.216 3.216 0 009.636 2.14a3.216 3.216 0 00-3.212 3.213v3.212z"
      ></path>
    </svg>
  );
};

export default PasswordIcon;
